import CartaSiniestro from "../domain/CartaSiniestro"
import CartaEnviadaController from "../domain/CartaEnviadaController"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class CartasSiniestrosServices {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async obtenerDetalleCartaEnviada(idDenuncia) {
    try {
      const cartasData = await this.apiService.fetchDetalleCartaEnviada(idDenuncia)

      const listadoCartas = Array.isArray(cartasData)
        ? cartasData.map((carta) => new CartaSiniestro(carta))
        : []

      return listadoCartas
    } catch (error) {
      console.error("Error obteniendo el detalle de cartas enviadas:", error)
      return []
    }
  }

  async obtenerCartaEnviadaPdf(idCartaEnviada) {
    try {
      const { blob } = await this.apiService.fetchCartaEnviadaPdf(idCartaEnviada)
      return blob
    } catch (error) {
      console.error("Error obteniendo la carta enviada:", error)
      return null
    }
  }
}

export default CartasSiniestrosServices
